/**
 * Dirty tracking and saving of a block with its own mutation (ADR 0006 D3).
 * The component defines the computed `blockInput` (the mutation input from `project`) and the
 * method `saveBlockInput(input)` (dispatches its mutation). Emits `dirty` (boolean) and `saved`.
 */
export const BlockSaveMixin = {
  data() {
    return {
      savedBlockInputJson: null,
      isSaving: false,
    };
  },
  computed: {
    blockInputJson() {
      return JSON.stringify(this.blockInput);
    },
    isDirty() {
      return this.blockInputJson !== this.savedBlockInputJson;
    },
  },
  watch: {
    // A new project object comes from the store (load, package assignment): saved state.
    project: {
      handler() {
        this.savedBlockInputJson = this.blockInputJson;
      },
      immediate: true,
    },
    isDirty(isDirty) {
      this.$emit('dirty', isDirty);
    },
  },
  methods: {
    async save() {
      const inputJson = this.blockInputJson;
      this.isSaving = true;
      try {
        await this.saveBlockInput(JSON.parse(inputJson));
        this.savedBlockInputJson = inputJson;
        this.$emit('saved');
      } catch (error) {
        // The store action shows the message.
        console.error(`Error saving block ${this.blockId}:`, error);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
